module.exports = __webpack_public_path__ + "static/img/step2.c9c9e19f.png";